import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Login from "../pages/login/login";
// import ClientRegister from "../pages/register/client/client";
import NewClientRegister from "../pages/register/client/NewClientRegister";
import NewResetPassword from "../pages/resetpassword/NewResetPassword";
// import RegisterMedium from "../pages/register/medium/medium";
import NewRegisterMedium from "../pages/register/medium/NewRegisterMedium";
import ResetPassword from "../pages/resetpassword";
// import ForgotPassword from "../pages/forgotpassword";
import NewForgetPassword from "../pages/forgotpassword/NewForgetPassword";
import Layout from "../layout/layout";
import Comingsoon from "../pages/comingsoon";
import MediumThanks from "../pages/mediumThanks";
import Homepage from "../pages/homepage";
import Overviewmedium from "../pages/overviewmedium";
import PractitionerInfo from "../pages/admin/professionalPublicView";
import Embeded from "../components/embeded";
import PayMyMedium from "../pages/paymymedium";
import GuestBooking from "../pages/guestbooking";
import SpecialEvents from "../pages/specialevents";
import InterviewBooking from "../pages/interviewbooking";
import ThankyouPopup from "../pages/client/appointment/premiumsessions/practitonerInfo/payment/thankyou";
import AppointmentConfirm from "../pages/client/appointmentconfirm";
import VerifyEmail from "../pages/admin/calendar/verifyemail";
import RegisterMediumVideo from "../pages/registration-video";
import Embeded1 from "../components/embeded/embeded1";
import VerySoulVerifiedBatch from "../components/embeded/verysoulverifiedbatch";
import VerySoulVerifiedBatchDark from "../components/embeded/verysoulverifiedbatchDark";
import VerySoulVerifiedBatchTransparent from "../components/embeded/verysoulverifiedbatchTransparent";
import Media from "../pages/media/media";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import NewLogin from "../pages/login/NewLogin";
import CheckInService from "../pages/checkinservice";
import OnboardingBooking from "../pages/onboardingbooking";
import LanguageSwitcher from "../components/languageSwitcher";

// Logged-out pages that must NOT show the language dropdown: embeddable widgets
// and verified badges that are shown inside other websites.
const NO_LANGUAGE_SWITCHER_PREFIXES = [
  "/embeded/",
  "/embeded-code/",
  "/verysoul-verified/",
  "/verysoul-verified-dark/",
  "/verysoul-verified-transparent/",
];

// These pages show the language dropdown inside their own header instead.
const HEADER_LANGUAGE_SWITCHER_PATHS = [
  "/",
  "/login",
  "/register-client",
  "/register-medium",
  "/forgot-password",
  "/reset-password",
];

const LoggedOutRoutes = () => {
  const location = useLocation();

  const showCaptcha =
    location.pathname === "/register-client" ||
    location.pathname === "/register-medium";

  const showLanguageSwitcher =
    !NO_LANGUAGE_SWITCHER_PREFIXES.some((prefix) =>
      location.pathname.startsWith(prefix)
    ) &&
    !HEADER_LANGUAGE_SWITCHER_PATHS.includes(
      location.pathname.replace(/\/+$/, "") || "/"
    );

     const appContent = (
      <>
      {showLanguageSwitcher && (
        <div className="auth-language-switcher">
          <LanguageSwitcher />
        </div>
      )}
      <Routes>
      <Route path="/login" element={<NewLogin />} />
      <Route path="/layout" element={<Layout />} />
      <Route path="/" element={<NewLogin />} />
      {/* <Route path="/overview-offereing-medium" element={<Overviewmedium />} /> */}
      <Route path="/verifyemail" element={<VerifyEmail />} />
      <Route path="/register-client" element={<NewClientRegister />} />
      <Route path="/register-medium" element={<NewRegisterMedium />} />
      <Route path="/reset-password" element={<NewResetPassword />} />
      <Route path="/forgot-password" element={<NewForgetPassword />} />
      <Route path="/profile-view/:id" element={<PractitionerInfo view={'public'} />} />
      <Route path="/embeded/:id" element={<Embeded />} />
      <Route path="/embeded-code/:id" element={<Embeded1 />} />
      <Route path="/verysoul-verified/:id" element={<VerySoulVerifiedBatch />} />
      <Route path="/verysoul-verified-dark/:id" element={<VerySoulVerifiedBatchDark />} />
      <Route path="/verysoul-verified-transparent/:id" element={<VerySoulVerifiedBatchTransparent />} />
      <Route path="/thank-you" element={<Comingsoon />} />
      <Route path="/thankyou" element={<ThankyouPopup />} />
      <Route path="/thanks" element={<MediumThanks />} />
      <Route path="/registration" element={<RegisterMediumVideo />} />
      <Route path="/paymymedium/:id" element={<PayMyMedium />} />
      <Route path="/guest-booking/:id" element={<GuestBooking />} />
      <Route path="/special-events" element={<SpecialEvents />} />
      <Route path="/appointment-confirmation/:id" element={<AppointmentConfirm />} />
      <Route path="/mediums-media" element={<Media />} />
      <Route path="/clients-media" element={<Media />} />
      <Route path="/general-public" element={<Media />} />
      <Route path="/" element={<Navigate to="/" />} />
      <Route path="*" element={<Navigate to="/" />} />
      <Route path="/interview-booking/:id" element={<InterviewBooking />} />
      <Route path="/check-in-service" element={<CheckInService />} />
      <Route path="/onboarding-booking/:mediumId" element={<OnboardingBooking />} />
    </Routes>
      </>
     );
  return showCaptcha ? (
    <GoogleReCaptchaProvider
      reCaptchaKey="6Lf1NZsrAAAAAHEtJwU8Ta4krTKEElLNaunFihcb"
      scriptProps={{
        async: true,
        defer: true,
        appendTo: "head",
      }}
    >
      {appContent}
    </GoogleReCaptchaProvider>
  ) : (
    appContent
  );
};
export default LoggedOutRoutes;
